/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import React from "react";
import styles from "src/components/visual/header.module.css";
import { QueryVisual } from "src/gql/visuals/types";
import { VisualProps } from "src/components/visual/visual";
import { queryLink } from "src/utils/links/links";
import { useTheme } from "src/components/theme/theme";
import { Avatar } from "src/components/avatar/avatar";

export type FooterOwnerProps = Pick<
  VisualProps<QueryVisual>,
  "owner" | "queryId" | "iframe" | "visual"
>;

export const FooterOwner: React.FC<FooterOwnerProps> = (props) => {
  const theme = useTheme();

  if (!props.owner) {
    return null;
  }

  return (
    <div className={styles.owner}>
      <span style={{ color: theme.created_by_color }}>
        <Link href={`/${props.owner.handle}`}>
          <Avatar
            src={props.owner.profile_image_url}
            ownerId={props.owner.id}
            handle={props.owner.handle}
            type={props.owner.type}
            size={12}
          />
        </Link>
      </span>
      <span className={styles["owner-label"]}>
        <span style={{ color: "var(--text-secondary)" }}>
          <Link href={`/${props.owner.handle}`}>@{props.owner.handle}</Link>
        </span>
        {props.queryId && props.iframe && (
          <>
            <span>{" with "}</span>
            <Link
              href={queryLink(props.queryId, props.visual.id)}
              style={{ color: theme.username_color }}
              target="_blank"
              rel="noreferrer"
            >
              Dune
            </Link>
          </>
        )}
      </span>
    </div>
  );
};
